// Shared formatters for the Performance section.

export const CURRENCY = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 2,
});

export const COMPACT = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  notation: 'compact',
  maximumFractionDigits: 1,
});

export const COMPACT_NUMBER = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 1,
});

export const NUMBER = new Intl.NumberFormat('en-US');

export function PERCENT(n: number, decimals = 2): string {
  if (!Number.isFinite(n)) return '0%';
  return `${n.toFixed(decimals)}%`;
}

export function RATIO_X(n: number): string {
  if (!Number.isFinite(n)) return '0x';
  return `${n.toFixed(2)}x`;
}
